<script lang="ts">
    import { Dialog } from "attractions";
    import Fa from "svelte-fa";
    import { faBolt } from "@fortawesome/free-solid-svg-icons";

    import Whoami from "./Whoami.svelte";

    export let onClose: () => void;
</script>

<Dialog title="Kraker is a Zebra Puzzle solver" closeCallback={onClose}>
    <div class="content-container">
        <div>
            <span class="title">But... what is a Zebra Puzzle?</span>
            <p>
                The puzzle is often called Einstein's Puzzle or Einstein's
                Riddle because it is said to have been invented by Albert
                Einstein as a boy.
            </p>
            <p>
                You are given hints about a number of people and their
                properties. A hint can be either positive or negative and
                follows the form:
            </p>
            <em
                >The person who has the property X [does not] has the property
                Y.</em
            >
            <p>
                Your task is to assign properties to the people so that all of
                the hints hold true.
            </p>

            <span class="title">How does Kraker work?</span>
            <p>
                Kraker uses a randomized Hill Climbing optimization algorithm.
                It starts from an initial random assignment, and iteratively it
                tries to improve the solution by making a minimal change in the
                assignment.
            </p>

            <Whoami />
        </div>

        <span class="made-with">Made with <Fa icon={faBolt} /> in Berlin</span>
    </div>
</Dialog>

<style lang="scss">
    @import "theme.scss";

    .content-container {
        width: 600px;
        display: flex;
        flex-direction: column;
    }

    .title {
        font-size: 18px;
        font-weight: bold;
    }

    .made-with {
        color: lighten($background, 50%);
        margin: auto;
    }
    .root-container {
        height: 1.25rem;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .command-line {
        font-family: monospace;
        font-size: 16px;
        color: #72f270;
        text-shadow: 0px 0px 2px #72f270;
        display: flex;
    }
</style>
